import React, { useState } from "react";
import SearchExportFilterComponent from "../Layout/SearchExportFilterComponent";
import TableLayout from "../Layout/TableLayout";
import Pagination from "../Layout/Pagination";
import ViewDetails from "./ViewDetails";

const ProductLeadReportOverview = ({
  data,
  loading,
  currentPage,
  totalPages,
  totalCount,
  setCurrentPage,
  setSearchTerm,
  setFilters,
  itemsPerPage,
  setItemsPerPage,
}) => {
  const [openDetailBox, setOpenDetailBox] = useState(false);
  const [selectedObject, setSelectedObject] = useState([]);
  const [visibleHeaders, setVisibleHeaders] = useState([
    "doctorsname",
    "Total_quantity",
    "products"
  ]);
  const tableHeaders = [
    { label: "Doctor", value: "doctorsname" },
    { label: "Quantity", value: "Total_quantity" },
    { label: "Products", value: "products" },
  ];
  const filterFields = [
    { type: "date", label: "From Date", id: "fromDate" },
    { type: "date", label: "To Date", id: "toDate" },
  ];
  const handleApplyFilters = (appliedFilters) => setFilters(appliedFilters);
  const handleResetFilters = () => setFilters({});
  const handleSearch = (term) => setSearchTerm(term);
  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };
  const handlePageChange = (page) => setCurrentPage(page);
  const handleExport = () => console.log("Exporting data:", data);

  const handleViewAction = (item) => {
    console.log("view");
    console.log("item", item);
    setSelectedObject(item);
    setOpenDetailBox(true);
  };

  return (
    <div className="px-0 sm:px-4">
      <SearchExportFilterComponent
        // exportFileName="ApplicationReport"
        onSearch={handleSearch}
        // onExport={handleExport}
        // searchPlaceholder="Search"
        tablefields={tableHeaders}
        selectedHeaders={visibleHeaders}
        onHeadersChange={setVisibleHeaders}
        fields={filterFields}
        onApply={handleApplyFilters}
        onReset={handleResetFilters}
        ExportOptionVisisbility={false}
      />
      <TableLayout
        data={data}
        loading={loading}
        headers={tableHeaders.filter((header) =>
          visibleHeaders.includes(header.value)
        )}
        handleAction={handleViewAction}
      />
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        onPageChange={handlePageChange}
        itemsPerPage={itemsPerPage}
        onItemsPerPageChange={handleItemsPerPageChange}
      />

      {openDetailBox && (
        <ViewDetails
          selectedObject={selectedObject}
          closeModal={() => setOpenDetailBox(false)}
        />
      )}
    </div>
  );
};

export default ProductLeadReportOverview;
